import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const BackArrowLeft = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 20 20" fill="none">
    <path
      d="M8 1L2 9L8 17"
      stroke={props.stroke || '#9AB1C0'}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </SvgIcon>
);
